import { FC, useState } from 'react';
import { ImageOff } from 'lucide-react';

import { cn } from '@/lib/utils';

interface PackShotProps {
  imagePath?: string | null;
  alt: string;
  className?: string;
}

export const PackShot: FC<PackShotProps> = ({
  imagePath,
  alt,
  className,
}: PackShotProps) => {
  const [error, setError] = useState(false);
  const showFallback = !imagePath || error;

  return (
    <div
      className={cn(
        'bg-muted relative aspect-square size-18 shrink-0 overflow-hidden',
        className
      )}>
      {showFallback ? (
        <div className='flex size-full items-center justify-center'>
          <ImageOff
            className='text-muted-foreground size-5'
            aria-hidden
          />
        </div>
      ) : (
        <img
          src={imagePath}
          alt={alt}
          className='size-full object-contain'
          loading='lazy'
          decoding='async'
          onError={() => {
            setError(true);
          }}
        />
      )}
    </div>
  );
};
